import "./style.css";
import gsap from "gsap";

export default class TeamMember {
  static selector = ".s-team-member";

  constructor(block) {
    this.block = block;
    this.active = false;
  }

  init() {
    this.$cta = this.block.querySelector(".s-team-member__content-cta");
    this.$holder = this.block.querySelector(".__holder");
    this.$helper = this.block.querySelector(".__helper");
    this.$title = this.block.querySelector("h5");

    this.block.addEventListener("click", () => {
      this.onInfoClick(true);
    });

    this.$cta.addEventListener("click", (e) => {
      if (this.active) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.onInfoClick(false);
      }
    });
  }

  onInfoClick(open) {
    if (this.active && open) return;

    if (!this.active) {
      const oldActive = document.querySelector(
        '.s-team-member[data-active="true"'
      );

      if (oldActive) {
        const $cta = oldActive.querySelector(".s-team-member__content-cta");
        $cta.click();
      }
    }

    this.active = !this.active;
    this.block.setAttribute("data-active", this.active);
    this.$title.classList[this.active ? "add" : "remove"]("h2");
    const width = window.innerWidth;
    const mtOffset = width >= 960 ? 88 : 0;
    const duration = 0;

    gsap.to(this.$helper, {
      duration: this.active ? duration : 0,
      delay: this.active ? 0 : 0.15,
      height: this.active ? this.contentHeight : 0,
      marginTop: this.active ? -mtOffset : 0,
      ease: "power2.inOut",
    });

    gsap.to(this.$holder, {
      duration: this.active ? duration : 0,
      delay: this.active ? 0.35 : 0,
      autoAlpha: this.active ? 1 : 0,
      y: this.active ? 0 : "15%",
      ease: "power2.inOut",
    });
  }

  onReady() {
    this.init();
  }

  onResize() {
    if (this.active) {
      const width = window.innerWidth;
      const mtOffset = width >= 960 ? 88 : 0;
      setTimeout(() => {
        gsap.set(this.$helper, {
          height: this.contentHeight,
          marginTop: -mtOffset,
        });
      }, 1);
    }
  }

  onDestroy() {
    this.$cta.removeEventListener("click", this.onInfoClick);
  }

  get contentHeight() {
    return this.$holder.getBoundingClientRect().height;
  }
}
